import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { VForm } from 'vuetify/components/VForm';
import { VImg } from 'vuetify/components/VImg';
import { VMain } from 'vuetify/components/VMain';
import { VContainer } from 'vuetify/lib/components/index.mjs';
import { VCol } from 'vuetify/lib/components/index.mjs';
import { VRow } from 'vuetify/lib/components/index.mjs';
import { VApp } from 'vuetify/components/VApp';
import * as directives from 'vuetify/directives';

export default createVuetify({
    components: {
      VForm,
      VRow,
      VCol,
      VImg,
      VApp,
      VMain,
      VContainer,
    },
    directives
  });
